export default {
  'disclaimer': 'Disclaimer',
  'privacy_policy_statement': 'Privacy and Policy',
  'security_information': 'Security Information',
  'risk_disclosure_statement': 'Risk Disclosure Statement',
  'telephone': 'Customer Service Hotline'
}
